import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requirePermission } from '~/utils/guards';

const AbacPoliciesPage = lazy(() => import('~/features/organization/pages/abac-policies-page'));

export const Route = createFileRoute('/_authenticated/_tenant/subsidiary/access-policy')({
  beforeLoad: requirePermission('organization_abac_policies'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <AbacPoliciesPage />
    </Suspense>
  ),
});
